import { isEmpty } from '../../Utils/Validations'
import './CheckboxOption.scss'

interface CheckboxOptionProps {
  label?: string
  className?: string
  value: boolean
  onChange?: (newValue: boolean) => void
  valueName?: string
  isReadOnly?: boolean
}
export function CheckboxOption({
  label,
  className,
  value,
  onChange,
  valueName,
  isReadOnly,
}: CheckboxOptionProps) {
  return (
    <div
      className={`checkbox-option ${className} ${
        isReadOnly ?? false ? 'is-read-only' : ''
      }`}
    >
      {!isEmpty(label) ? <div className="input-label">{label}</div> : null}
      <div className="input-wrapper">
        <input
          type="checkbox"
          checked={value}
          onChange={() => {
            if (!(isReadOnly ?? false) && onChange) onChange(!value)
          }}
          readOnly={isReadOnly}
        />
        {!isEmpty(valueName) ? (
          <span className="value-name">{valueName}</span>
        ) : null}
      </div>
    </div>
  )
}
